import { render, staticRenderFns } from "./AllExhibitPage.vue?vue&type=template&id=179fe25e&scoped=true&"
import script from "./AllExhibitPage.vue?vue&type=script&lang=js&"
export * from "./AllExhibitPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179fe25e",
  null
  
)

export default component.exports